import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { ButtonComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-facility-filter-service',
  standalone: true,
  imports: [
    CommonModule,
    NgbPopoverModule,
    ButtonComponent,
    FormsModule,
    IconComponent,
  ],
  templateUrl: './facility-filter-service.component.html',
  styleUrls: ['./facility-filter-service.component.scss'],
})
export class FacilityFilterServiceComponent implements OnChanges {
  @Input() availableServices: Record<string, boolean> = {};
  @Input() selectedServices: string[] = [];
  @Output() updateSelectedServices = new EventEmitter<string[]>();
  @ViewChild('popoverTrigger') popoverTrigger!: NgbPopover;
  private platformId = inject(PLATFORM_ID);

  public servicesOnInit: string[] = [
    'Emergency Response Services',
    'Field & Industrial Services',
    'Treatment & Disposal Services',
    'E & P Services',
  ];
  public selectedServicesObject: Record<string, boolean> = {};
  public hasSelectedServices = false;

  public handleSelection(): void {
    this.hasSelectedServices = Object.values(this.selectedServicesObject).some(
      (value) => value
    );
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedServices']?.currentValue.length > 0) {
      changes['selectedServices'].currentValue.forEach(
        (selectedService: string) => {
          this.selectedServicesObject[selectedService] = true;
          this.handleSelection();
        }
      );
    } else {
      this.selectedServicesObject = {};
    }
  }

  public get getAvailableServices(): string[] {
    const availableServices = Object.keys(this.availableServices);
    return availableServices.length === 0
      ? this.servicesOnInit
      : availableServices;
  }

  public applyServices(p: NgbPopover): void {
    const selectedServicesNames = Object.keys(
      this.selectedServicesObject
    ).filter((serviceName) => this.selectedServicesObject[serviceName]);
    this.updateSelectedServices.emit(selectedServicesNames);
    if (p) {
      p.close();
    }
  }

  public clearAll(): void {
    this.selectedServicesObject = {};
    this.availableServices = {};
    this.hasSelectedServices = false;
    this.applyServices(this.popoverTrigger);
  }

  public disableScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 1200) {
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
      }
    }
  }

  public enableScroll(): void {
    document.body.style.overflow = 'initial';
  }
}
